import { twMerge } from 'tailwind-merge';
import MuiButton from '@mui/material/Button';

import { ButtonProps } from './types';
import {
  colorClassname,
  variantClassname,
  gradientBorderClassname,
} from './styles';

export const Button = ({
  children,
  className,
  fullWidth,
  hasMinWidth,
  textClassName,
  buttonClassName,
  color = 'primary',
  variant = 'contained',
  ...props
}: ButtonProps) => {
  const baseClasses = variantClassname[variant];
  const colorClasses = colorClassname[color]?.[variant];
  const gradientBorderClasses =
    variant === 'outlined' && gradientBorderClassname[color]?.[variant];

  return (
    <span
      className={twMerge(
        'inline-flex align-middle',
        gradientBorderClasses,
        fullWidth && 'w-full',
        className
      )}
    >
      <MuiButton
        disableRipple
        className={twMerge(
          `h-10 w-full rounded-lg p-2.5 normal-case`,
          baseClasses,
          colorClasses,
          buttonClassName,
          hasMinWidth && 'min-w-0'
        )}
        {...props}
      >
        <span
          className={twMerge('text-sm leading-[22px] font-bold', textClassName)}
        >
          {children}
        </span>
      </MuiButton>
    </span>
  );
};
